'use strict';

/**
 * Adds commas to a number
 * @param {string} text
 */
module.exports = function(text) {
    console.log("My first module works: " + text);
};